/* =====================================================================
   SH4DE — prix de livraison exacts en direct (point relais / domicile)
   Recalcule les blocs [data-sd-shq] à chaque changement du panier,
   avec le poids réel du panier (+ la pièce affichée sur la fiche produit).
   Grille : window.SD_SHIP (snippets/sd-ship.liquid), identique au paiement.
   ===================================================================== */
(function () {
  'use strict';
  var C = window.SD_SHIP;
  var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-sd-shq]'));
  if (!C || !blocks.length) return;

  function tier(max, prc, w) {
    for (var i = 0; i < max.length; i++) if (w <= max[i]) return prc[i];
    return -1;
  }
  function eur(c) {
    var n = c / 100;
    return (c % 100 ? n.toFixed(2).replace('.', ',') : String(n)) + ' €';
  }
  function fill(t, amount) { return String(t || '').replace(/__A__/g, amount); }

  function paint(el, w, s) {
    var rp = tier(C.r, C.rp, w), hp = tier(C.h, C.hp, w);
    var free = s >= C.free;
    var off = el.getAttribute('data-t-off');
    var r = el.querySelector('[data-sd-r]'), h = el.querySelector('[data-sd-h]'), f = el.querySelector('[data-sd-f]');
    if (r) r.textContent = free ? off : (rp >= 0 ? eur(rp) : '—');
    if (h) h.textContent = free ? off : (hp >= 0 ? eur(hp) : '—');
    if (f) {
      if (free) f.textContent = el.getAttribute('data-t-free');
      else {
        var parts = [];
        if (rp >= 0 && hp > rp) parts.push(fill(el.getAttribute('data-t-save'), eur(hp - rp)));
        parts.push(fill(el.getAttribute('data-t-left'), eur(C.free - s)));
        f.textContent = parts.join(' ');
      }
    }
    el.classList.toggle('is-free', free);
  }

  var getCart = window.__sdFetch || window.fetch;
  function refresh() {
    getCart.call(window, '/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        blocks.forEach(function (el) {
          var aw = parseInt(el.getAttribute('data-aw'), 10) || 0;
          var ap = parseInt(el.getAttribute('data-ap'), 10) || 0;
          paint(el, (cart.total_weight || 0) + aw, (cart.items_subtotal_price || 0) + ap);
        });
      })
      .catch(function () {});
  }

  // Le tiroir panier est re-dessiné à chaque ajout / retrait : on recalcule à ce moment-là.
  var items = document.getElementById('CartItems');
  if (items && 'MutationObserver' in window) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 120); })
      .observe(items, { childList: true, subtree: true, characterData: true });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
